export const DELETE = "Eliminar";
